import React from 'react';
import { formatLocalDate } from '../../utils/dateUtils';

function formatCell(value, type) {
  if (value == null || value === '') return '—';
  if (type === 'date') return formatLocalDate(value) || String(value);
  return String(value);
}

function DataTable({ columns = [], rows = [], footerTotals = null }) {
  if (!columns.length) return <p className="text-muted">No columns</p>;

  return (
    <div className="table-wrap">
      <table>
        <thead>
          <tr>
            {columns.map((col) => <th key={col.key}>{col.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-muted">No rows</td>
            </tr>
          ) : (
            rows.map((row, idx) => (
              <tr key={row.id || idx}>
                {columns.map((col) => (
                  <td key={col.key}>{formatCell(row[col.key], col.type)}</td>
                ))}
              </tr>
            ))
          )}
        </tbody>
        {footerTotals && rows.length > 0 && (
          <tfoot>
            <tr>
              {columns.map((col, index) => {
                if (index === 0) {
                  return (
                    <td key={col.key} style={{ fontWeight: 700 }}>
                      {footerTotals.label || 'Total'}
                    </td>
                  );
                }
                if (Object.prototype.hasOwnProperty.call(footerTotals.values || {}, col.key)) {
                  return (
                    <td key={col.key} className="mono" style={{ fontWeight: 700 }}>
                      {footerTotals.values[col.key] ?? '—'}
                    </td>
                  );
                }
                return <td key={col.key} />;
              })}
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}

export default function ReportTable({
  columns = [],
  rows = [],
  summary = null,
  vehicleSummary = null,
  reportKey = '',
}) {
  const showTripFooter = reportKey === 'vehicle-trip-detail' && Boolean(summary);
  const tripFooter = showTripFooter
    ? {
        label: 'Total kilometer',
        values: {
          expectedKM: summary?.totalExpectedKm,
          actualKM: summary?.totalActualKm,
          difference: summary?.totalDifferenceKm,
        },
      }
    : null;

  const cards = Array.isArray(summary?.cards) && summary.cards.length > 0
    ? summary.cards
    : (summary
      ? [
          { label: 'Total trips', value: summary.totalTrips ?? rows.length },
          { label: 'Total expected km', value: summary.totalExpectedKm ?? '—' },
          { label: 'Total actual km', value: summary.totalActualKm ?? '—' },
        ]
      : []);

  return (
    <div className="card">
      {vehicleSummary?.rows?.length > 0 && (
        <>
          <div className="card-title">By vehicle</div>
          <DataTable
            columns={vehicleSummary.columns || []}
            rows={vehicleSummary.rows}
          />
          <div className="card-title" style={{ marginTop: 20 }}>Fill detail</div>
        </>
      )}

      <DataTable columns={columns} rows={rows} footerTotals={tripFooter} />

      {cards.length > 0 && (
        <div className="stat-grid" style={{ marginTop: 16, marginBottom: 0 }}>
          {cards.map((card) => (
            <div className="stat-card" key={card.label}>
              <div className="stat-label">{card.label}</div>
              <div className="stat-value" style={{ fontSize: 22 }}>{card.value ?? '—'}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
